import aesReduxConstants from '../../../constants';

const currentSopReducer = function() {
  const constants = aesReduxConstants;

  const defaultState = {
    // need to set these values for the new form to update
    page: null,
    versions: [],
    preview: '',
    demo: false,
    pageNotFound: false,
    loading: false,
  };

  const reducer = function(state, action) {
    if (state === undefined) {
      state = defaultState;
    }

    let delta = {};
    switch (action.type) {
      case constants.SET_CURRENT_SOP_PAGE:
      case constants.GET_CLIENT_SOP_PAGE:
        delta = { loading: true };
        break;
      case constants.GET_CLIENT_SOP_PAGE_SUCCESS:
        delta = {
          page: action.page, loading: false, pageNotFound: false, demo: action.page.demo,
        };
        break;
      case constants.GET_CLIENT_SOP_PAGE_NOT_FOUND:
        delta = { loading: false, pageNotFound: true };
        break;
      case constants.GET_CLIENT_SOP_PAGE_VERSIONS:
        delta = { loading: true };
        break;
      case constants.GET_CLIENT_SOP_PAGE_VERSIONS_SUCCESS:
        delta = { versions: action.versions, loading: false };
        break;
      case constants.GET_SOP_PAGE_PREVIEW:
        delta = { preview: action.preview };
        break;
      case constants.UPDATE_CURRENT_SOP_PAGE_CONTENT:
        var pageUpdateContent = Object.assign({}, state.page, { content: action.content });
        delta = { page: pageUpdateContent };
        break;
      case constants.UPDATE_CURRENT_SOP_PAGE_TITLE:
        var pageUpdateTitle = Object.assign({}, state.page, { title: action.title });
        delta = { page: pageUpdateTitle };
        break;
      case constants.ARCHIVE_CLIENT_SOP_PAGE_SUCCESS:
        var pageUpdateTitle = Object.assign({}, state.page, { archived: action.archived });
        delta = { page: pageUpdateTitle };
        break;

      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default currentSopReducer();
